// import React, { useRef, useEffect } from 'react'
import React, { useRef, useEffect, useState } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import { saveAs } from 'file-saver';



function NextArrow({ onClick }) {
  return (
    <>
      <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
        <IoIosArrowForward className='mx-auto text-xl' />
      </div>
    </>
  )
}
function PrevArrow({ onClick }) {
  return (
    <>
      <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
        <IoIosArrowBack className='mx-auto text-xl' />
      </div>
    </>
  )
}
export default function LatestEvent() {

  const sliderRef = useRef(null);

  const [lastActiveDarshan, setLastActiveDarshan] = React.useState({

    fileHdUrls: [],
  
  });
  const downloadHDImg = (eachUrl) => {
    // const url = eachUrl.includes("https://") ? eachUrl : `${s3Url}${eachUrl}`;
    const url = eachUrl;
    saveAs(url);
  };
  const extractFileName = (url) => {
    return url.substring(url.lastIndexOf("/") + 1);
  };


  useEffect(() => {
    fetch('https://smvdev.swaminarayansurat.com/admin/daily-darshan') // <-- Replace with your real API endpoint
      .then(res => res.json())
      .then(data => {
        // Adjust according to your API response structure
        setLastActiveDarshan({ fileHdUrls: data.data.fileHdUrls || [] });
      })
      .catch(err => console.error('Error fetching daily darshan:', err));
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
  }
  return (
    <>
      {/* <div className='py-20 bg-[#FFF5F3] flowers-line'>
        <div className='bg-[#FFF5F3]'>
          <image src="./assets/shapeline.png" />
        </div> */}
        <div className='max-w-7xl mx-auto px-4'>
          <div className=' w-full flex gap-4'>
            {/* Left text block */}
            <div className='max-w-[520px]'>
              <h2 className='text-6xl mb-4' style={{ fontFamily: 'Philosopher, sans-serif' }}> Ramnavmi <br></br><span className='text-primary'>Event</span> photos & Videos</h2>
              <p>Ram Navami is the birth anniversary of Lord Rama, the seventh avatar of Lord Vishnu. April 05, 2025 our ved mandir event.</p>
              <div className='flex items-center mt-9'>
                <PrevArrow onClick={() => sliderRef.current.slickPrev()} />
                <NextArrow onClick={() => sliderRef.current.slickNext()} />
                <Link className='uppercase text-primary ml-6 text-lg font-medium flex items-center'><div className='mr-2'>View More</div> <MdKeyboardDoubleArrowRight /></Link>
              </div>
            </div>

            {/* Right slider block */}
            <div className='flex-1 mt-7 min-w-0'>
              <Slider ref={sliderRef} {...settings} className='-top-4 -ml-4 -mr-4'>
                {lastActiveDarshan.fileHdUrls?.length > 0 ? (
                  lastActiveDarshan.fileHdUrls.map((eachUrl, indx) => {
                    return (
                      <>
                      <div className='pl-4 pr-4'>  
                        <div
                          key={`darshan-hd-${indx}-${extractFileName(eachUrl)}`}
                          className="h-full p-2 bg-white rounded-[20px]"
                          // style={{ width: "16%" }}
                        >
                          {/* <div className="mb-1 text-black">{`${indx + 1
                            }) ${extractFileName(eachUrl)}`}</div> */}
                          <div className="w-full rounded-[10px] overflow-hidden h-full relative">
                            <img
                              alt="gallery"
                              className="block h-full w-full rounded-lg object-cover object-center"
                              src={`${eachUrl}`}
                            />
                            {/* <div className="absolute w-full h-full flex items-center justify-center gap-x-3 bg-[rgba(0,0,0,0.60)] opacity-0 inset-0 hover:opacity-100 transition-all duration-300 ease-[ease]">
                              <button
                                className="w-10 h-10 bg-white flex items-center justify-center p-1.5 rounded-[50%] transition-all duration-300 ease-[ease] hover:scale-[1.06]"
                                onClick={() => handleOpenImgPreview(eachUrl)}
                              >
                                <Icon path={mdiEye} size={1} />
                              </button>

                              <button
                                className="w-10 h-10 bg-white flex items-center justify-center p-1.5 rounded-[50%] transition-all duration-300 ease-[ease] hover:scale-[1.06]"
                                onClick={() => downloadHDImg(eachUrl)}
                              >
                                <Icon path={mdiDownload} size={1} />
                              </button>
                              <button
                                className="w-10 h-10 bg-white flex items-center justify-center p-1.5 rounded-[50%] transition-all duration-300 ease-[ease] hover:scale-[1.06]"
                                onClick={() =>
                                  removeDailyDarshan(
                                    eachUrl,
                                    lastActiveDarshan.date,
                                    "hd"
                                  )
                                }
                              >
                                <Icon path={mdiTrashCan} size={1} />
                              </button>
                            </div> */}
                          </div>
                        </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div className="text-xs text-[#A4A4A4]">
                    000
                  </div>
                // </div>
                )}
                {/* <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div>
                <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div>
                <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div>
                <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div>
                <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div>
                <div className='p-3'>
                  <div className='bg-white p-2 rounded-3xl overflow-hidden inline-block w-72'>
                    <img src='./assets/dailydarshan.png' alt='daily-darshan' className='mb-3 rounded-2xl overflow-hidden' />
                    <div className='text-xl text-center'>25/07/2023</div>
                  </div>
                </div> */}
              </Slider>
            </div>
          </div>
        </div>
      {/* </div> */}
    </>
  )
}

